import React from "react";
import Card from "react-bootstrap/Card";

const BankDetails = ({ customerById }) => {
  const bank_details = customerById?.bank_details || [];
  return (
    <>
      <Card>
        {bank_details &&
          bank_details.length > 0 &&
          bank_details.map((item) => (
            <Card.Header>
              <Card.Text className="w-100">
                <div className="row">
                  <div className="col-md-3 mb-3">
                    <span>Account Number</span> <br />
                    <strong>{item.account_number ? item.account_number : "Not Available"}</strong>
                  </div>
                  <div className="col-md-3 mb-3">
                    <span>Bank Name</span> <br />
                    <strong>{item.name ? item.name : "Not Available"}</strong>
                  </div>
                  <div className="col-md-3 mb-3">
                    <span>IFSC Code</span> <br />
                    <strong>{item.ifsc ? item.ifsc : "Not Available"}</strong>
                  </div>
                  <div className="col-md-3 mb-3">
                    <span>Primary Account</span> <br />
                    {item.is_primary ? (
                      <span className="fs-4 fw-bold" style={{ color: "green" }}>
                        Yes
                      </span>
                    ) : (
                      <span className="fs-4 fw-bold" style={{ color: "red" }}>
                        No
                      </span>
                    )}
                  </div>
                </div>
              </Card.Text>
            </Card.Header>
          ))}
      </Card>
    </>
  );
};

export default BankDetails;
